// Reusable US Letter UNFI pallet placard (prominent DC/PO/pallet + item table); no barcodes.
// Generated by scripts/wms/generate.ts for PHP-419. Schema + mappings are the runtime contract.
import * as yup from 'yup'

import { MakeRequiredAndNullable } from './utils.js'

export const biomUnfiPalletPlacardFileDataSchema = yup.object().shape({
  customerDisplayName: yup.string().nullable().optional(),
  unfiDcName: yup.string().nullable().optional(),
  unfiDcAddress: yup.string().nullable().optional(),
  unfiPoNumber: yup.string().nullable().optional(),
  palletSequence: yup.string().nullable().optional(),
  palletCount: yup.string().nullable().optional(),
  carrier: yup.string().nullable().optional(),
  pickupDate: yup.string().nullable().optional(),
  bolLoadNumber: yup.string().nullable().optional(),
  dateColumnLabel: yup.string().nullable().optional(),
  itemRows: yup
    .array()
    .of(
      yup.object().shape({
        upcSupplierItem: yup.string().nullable().optional(),
        quantity: yup.string().nullable().optional(),
        quantityUom: yup.string().nullable().optional(),
        lineItemDate: yup.string().nullable().optional(),
        countryOfOrigin: yup.string().nullable().optional(),
      }),
    )
    .required(),
})

export type BiomUnfiPalletPlacardFileData = yup.InferType<
  typeof biomUnfiPalletPlacardFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<BiomUnfiPalletPlacardFileData>

/** Each leaf is a stable GeneratedFileField UUID (or null for computed/derived fields). */
export const biomUnfiPalletPlacardFileMappings: RequiredFileData = {
  customerDisplayName: '001d90cd-9285-4f96-a73a-8db74e65f1a8',
  unfiDcName: '68ec55bd-b32c-49e0-ad9a-9ea12d6ba0ba',
  unfiDcAddress: 'f4db41df-ebbb-4381-aaee-703ab00e65f2',
  unfiPoNumber: '3c312c3f-1609-405a-b3d5-90bcebf507ae',
  palletSequence: 'e3e53b0c-7583-43f8-80c4-4717f33a980f',
  palletCount: 'f9626dfc-362a-48ed-874c-d416ace38311',
  carrier: '48d8bfd7-3e52-4737-9f0b-6396995821bf',
  pickupDate: 'cd582c90-5e92-4ca7-a001-3cf15704d7bd',
  bolLoadNumber: '7a15765d-af26-4497-aebe-53dcb9c0f9f2',
  dateColumnLabel: '7d3e4d6a-520f-41f4-8cc2-85f1fa15b746',
  itemRows: [
    {
      upcSupplierItem: '61c47ec3-2850-46a2-9558-9557492715ed',
      quantity: 'f3570140-72e4-46c3-a8ed-733f6218fcb2',
      quantityUom: '8e1f09b2-2fe3-4bbb-9bb5-547e26f2eac6',
      lineItemDate: 'ef18d4f3-cf8b-452f-8471-89f9b67a43d8',
      countryOfOrigin: '49be90c4-2ac6-4773-95e1-b3f1f30efc6e',
    },
  ],
}
